import {ModelInterface, Uuid} from "@hidat/huijs-common";
import {
  ModelStatusResource,
  NameableResource,
  RailsUpdateTrackingResource,
  ResourceConfig
} from "@hidat/huijs-resource";

export const UserConfig: ResourceConfig =
  new ResourceConfig('User', 'users', false, true)

export interface UserInterface extends ModelInterface, RailsUpdateTrackingResource, NameableResource, ModelStatusResource {
  id: Uuid | undefined;
  email: string | undefined;
}
